// extracted by mini-css-extract-plugin
module.exports = {"inputNumber":"LotsCreateForm_inputNumber__k3t_Z"};